import type { RulesOptions } from 'vuetify/labs/rules'

export const vuetifyRulesOptions: RulesOptions = {
  // https://vuetifyjs.com/en/features/rules/#custom-rules
  aliases: {
    max: (max: number, err?: string) => {
      return (v: any) => isEmpty(v) || v >= max || err || `Can't be more than ${max}`
    },
    min: (min: number, err?: string) => {
      return (v: any) => isEmpty(v) || v >= min || err || `Must be at least ${min}`
    },
  }
}

function isEmpty(value: any) {
  return ['', undefined, null].includes(value)
}
